module.exports = __webpack_public_path__ + "font6.61d3b4d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/font6.png
// module id = LXK4
// module chunks = 0